
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conjure/intake2",
      function () {
        return require("private-next-pages/conjure/intake2.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conjure/intake2"])
      });
    }
  